var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lost-password',{attrs:{"resetPassword":_vm.resetPassword},on:{"loggedIn":function($event){return _vm.$router.push({name: 'dashboard'})},"failedToLogin":function($event){return _vm.$store.dispatch('alert/error', $event.data.status)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9528143c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/public/LostPassword.vue
// module id = null
// module chunks = 